import api from 'services/api';
import config from 'config';
import React, { useEffect, useState } from 'react';
import { formatDate } from 'components/formatos';
import { getestabelecimentos } from 'functions/gettabconfig';
import NAVBAR from 'components/navbar';

function APROVAAVALIACAO() {
    const [idestabelecimento, setIdestabelecimento] = useState(getestabelecimentos(0));
    const [avaliacoes, setAvaliacoes] = useState([]);

    const refreshAvaliacoes = () => {
        api.get(`${config.ESTABELECIMENTOS_AVALIACAO}?id=${idestabelecimento}&aprovado=N`)
            .then(response => {
                setAvaliacoes(response.data)
            })
            .catch(err => console.log(err));
    };

    const aprovaravaliacoes = (id, index) => {
        api.post(`${config.ADM_ESTABELECIMENTOS_AVALIACAO}/aprovar/${id}`,
            { ies_aprovacao: 'S', den_resposta: avaliacoes[index].den_resposta })
            .then(response => {
                refreshAvaliacoes();
            })
    };

    const deletaravaliacoes = (id) => {
        api.delete(`${config.ADM_ESTABELECIMENTOS_AVALIACAO}/aprovar/${id}`)
            .then(response => {
                refreshAvaliacoes();
            })
    };
    const setValor = (id, index, valor) => {
        const newAvaliacoes = [...avaliacoes];
        newAvaliacoes[index].den_resposta = valor;
        setAvaliacoes(newAvaliacoes);
    }

    useEffect(() => {
        api.get(`${config.ESTABELECIMENTOS_AVALIACAO}?id=${idestabelecimento}&aprovado=N`)
            .then(response => {
                setAvaliacoes(response.data)
            })
            .catch(err => console.log(err));
    }, []);


    return (<div>
        <NAVBAR />

        <div className="mt-page">
            <h1>Avaliações para aprovação</h1>
            {
                avaliacoes.length === 0 ?
                    <div className="alert alert-info" role="alert">
                        Nenhuma avaliação pendente.
                    </div> 
           : <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Usuário</th>
                        <th>data</th>
                        <th>descricao</th>
                        <th>resposta</th>
                        <th>acao</th>
                    </tr>
                </thead>
                <tbody>
                    {avaliacoes.map((item, index) => (
                        <tr key={item.id_avaliacao}>
                            <td>{item.nomeusuario}</td>
                            <td>{formatDate(item.datahora)}</td>
                            <td>{item.den_avaliacao}</td>
                            <td><input type='text' value={item.den_resposta}
                                onChange={(e) => setValor(item.id_avaliacao, index, e.target.value)} /></td>
                            <td>
                                <button type='button' className='btn btn-primary'
                                    onClick={() => aprovaravaliacoes(item.id_avaliacao, index)}>
                                    ✔️ Aprovar
                                </button>
                                <button type='button'
                                    className='btn btn-danger'
                                    onClick={() => deletaravaliacoes(item.id_avaliacao, index)}>
                                    🗑️ Deletar
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        }
        </div>
    </div>);
};

export default APROVAAVALIACAO;